import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaFileExcel } from "react-icons/fa";
import NavBar from "../components/NavMenu";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const DetailStudentEvaluation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const passedQuarters = location.state?.selectedQuarters || ["Q1 2025"];
  const [selectedQuarters] = useState(passedQuarters);
  const [evaluationData, setEvaluationData] = useState([]);
  const [loading, setLoading] = useState(true);

  const parseQuarterYear = (quarterStr) => {
    const [qtr, year] = quarterStr.split(" ");
    return { qtr: parseInt(qtr.replace("Q", "")), year: parseInt(year) };
  };

  useEffect(() => {
    const fetchEvaluationData = async () => {
      setLoading(true);
      const { qtr, year } = parseQuarterYear(selectedQuarters[0]);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}/getStudentEvalByLecturer?qtr=${qtr}&year=${year}`
        );
        const current = res.data.current || [];
        setEvaluationData(current);
      } catch (err) {
        console.error("Failed to fetch evaluation data", err);
      } finally {
        setLoading(false);
      }
    };
    fetchEvaluationData();
  }, [selectedQuarters]);

  const handlePrevious = () => {
    const { qtr, year } = parseQuarterYear(selectedQuarters[0]);
    navigate("/home", {
      state: {
        view: "reenrolment",
        selectedQuarter: qtr,
        selectedYear: year,
      },
    });
  };

  return (
    <>
      <NavBar />
      <div
        style={{
          backgroundColor: "#373636",
          margin: 20,
          borderRadius: 10,
          padding: 30,
          minHeight: "calc(100vh - 80px)",
          color: "#fff",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 20,
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <FaArrowLeft
              size={18}
              onClick={handlePrevious}
              style={{ cursor: "pointer" }}
            />
            <h4 style={{ margin: 0 }}>Student Evaluation by Lecturer</h4>
             <span
              style={{
                background: "#444",
                padding: "6px 12px",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              {selectedQuarters[0]}
            </span>
            <span
              style={{
                background: "#444",
                padding: "6px 12px",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 500,
              }}
            >
               Total Records: {evaluationData.length}
            </span>
          </div>
          <button
            onClick={() => console.log("Export to Excel")}
            className="excel-button"
          >
            <FaFileExcel size={18} /> Export to Excel
          </button>
        </div>

        {loading ? (
          <div style={{ textAlign: "center", marginTop: 50 }}>Loading...</div>
        ) : (
          <div style={{ overflowX: "auto", borderRadius: 6 }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                backgroundColor: "#1f1f1f",
                borderRadius: 6,
                overflow: "hidden",
              }}
            >
              <thead style={{ backgroundColor: "#000" }}>
                <tr>
                  <th style={thStyle}>NO</th>
                  <th style={thStyle}>COURSE</th>

                  <th style={thStyle}>LECTURER NAME</th>
                  <th style={thStyle}>AVG SCORE</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(
                  evaluationData.reduce((acc, item) => {
                    const course = item.course || "Unknown Course";
                    if (!acc[course]) acc[course] = [];
                    acc[course].push(item);
                    return acc;
                  }, {})
                )
                  .sort(([a], [b]) => a.localeCompare(b))
                  .map(([course, items], groupIndex) => (
                    <React.Fragment key={groupIndex}>
                      <tr>
                        <td colSpan={5} style={groupHeaderStyle}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span>{course}</span>
                            <span
                              style={{
                                backgroundColor: "#ffa726",
                                padding: "4px 10px",
                                borderRadius: "999px",
                                fontSize: 13,
                                fontWeight: 500,
                                color: "#000",
                                minWidth: 28,
                                textAlign: "center",
                              }}
                            >
                              {items.length}
                            </span>
                          </div>
                        </td>
                      </tr>
                      {items.map((row, idx) => (
                        <tr
                          key={idx}
                          style={{
                            borderTop: "1px solid #444",
                            backgroundColor:
                              idx % 2 === 0 ? "#2b2b2b" : "#252525",
                          }}
                        >
                          <td style={tdStyle}>{idx + 1}</td>
                          <td style={tdStyle}>{row.course}</td>
                          <td style={tdStyle}>{row.display_name}</td>
                          <td style={tdStyle}>{row.avgSec}</td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

const thStyle = {
  padding: "14px 12px",
  fontWeight: "bold",
  fontSize: 15,
  color: "#fff",
  borderBottom: "1px solid #444",
  textAlign: "center",
};
const tdStyle = {
  padding: "12px 12px",
  color: "#ddd",
  fontSize: 14,
  textAlign: "center",
};
const groupHeaderStyle = {
  backgroundColor: "#111",
  fontWeight: "bold",
  color: "#fff",
  padding: "10px 12px",
  textAlign: "left",
};

export default DetailStudentEvaluation;
